import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Box, Button, Flex, Image } from "rebass";
import useResponsive from "../hooks/useResponsive";
import { userActions } from "../logic/actions";
import { yodaMaintenanceService } from "../logic/services";
import facebookLogo from "../static/images/facebook.svg";
import logoImage from "../static/images/hernoLogo333.png";
import instagramLogo from "../static/images/instagram.svg";
import logoCondensed from "../static/images/logoCondensed.svg";
import pinterestLogo from "../static/images/pinterest.svg";
import twitterLogo from "../static/images/twitter-logo-white.png";
import { getLocalizedString, history, theme } from "../utils";
import config from "../utils/globalConfig";
const MaintenancePage = () => {
  const headerHeight = 50;

  const dispatch = useDispatch();

  const { isMobile } = useResponsive();
  const [maintenanceButtonDisabled, setMaintenanceButtonDisabled] =
    useState(false);

  useEffect(() => {
    if (history.location.state?.authError) {
      console.warn(
        `B2B Authorization error: ${history.location.state.authError}`,
      );
    }
    if (history.location.state?.yodaError) {
      console.warn(`Yoda Authorization error`);
    }
    if (history.location.state?.roleError) {
      console.warn(`incompatible role`);
    }
  }, []);

  const resetCache = async () => {
    const now = new Date();
    const config = {
      isInMaintenance: true,
      expires: now.getTime(),
    };
    sessionStorage.setItem("maintenanceConfig", JSON.stringify(config));
  };

  return (
    <Flex
      width={1}
      height={"100dvh"}
      minHeight={"100dvh"}
      flexDirection={"column"}
      bg={theme.background}
      color="#fff"
    >
      {/* HEADER */}
      <Flex
        width="100%"
        height={headerHeight}
        maxHeight={headerHeight}
        bg={theme.background}
        justifyContent="space-between"
        alignItems="center"
      >
        <Box></Box>
        <Flex
          height={"100%"}
          justifyContent="center"
          onClick={() => history.replace("/homepage")}
          sx={{
            visibility: "hidden",
          }}
        >
          <img
            alt="Herno Logo"
            src={logoImage}
            p={4}
            style={{
              objectFit: "scale-down",
            }}
          />
        </Flex>
        {/* LOGOUT */}
        <Flex
          px="16px"
          sx={{
            gap: "5px",
            borderBottom: "0.5px solid #303130",
          }}
          alignItems="center"
          {...(isMobile && {
            paddingLeft: "5px",
          })}
        >
          <Link
            p={2}
            to="#"
            onClick={(e) => {
              e.preventDefault();
              dispatch(userActions.logout());
            }}
          >
            <Image src={logoCondensed} height={25} width={25}></Image>
          </Link>
        </Flex>
        {/* END - LOGOUT */}
      </Flex>
      {/* END - HEADER */}
      <Flex flexGrow={1} justifyContent="center">
        <Flex width={1} flexDirection="column">
          <Flex
            width={["100%", config.VIEWPORT]}
            padding={["0 8px", 0]}
            flexDirection="column"
            alignItems={["center", "flex-start"]}
            sx={{
              marginLeft: "auto",
              marginRight: "auto",
              gap: ["30px", "20px"],
              fontWeight: 600,
            }}
            flexGrow={1}
          >
            <Box
              sx={{
                transform: ["none", "translate(-30px)"],
              }}
            >
              <img
                alt="Herno Logo"
                src={logoImage}
                style={{
                  height: 70,
                  objectFit: "scale-down",
                }}
              />
            </Box>
            <Box
              as="h1"
              textAlign={["center", "start"]}
              fontSize={["42px", "64px"]}
            >
              {getLocalizedString("MAINTENANCE_TITLE")}
            </Box>
            <Box textAlign={["center", "start"]} fontSize={["20px", "32px"]}>
              {getLocalizedString("MAINTENANCE_SUB")}
            </Box>
            <Box textAlign={["center", "start"]} fontSize={["16px", "20px"]}>
              {getLocalizedString("MAINTENANCE_SOCIAL_CTA")}:
            </Box>
            <Flex width="fit-content">
              <a
                style={{ textDecoration: "none" }}
                href="https://www.facebook.com/HernoSpa/"
                target="_blank"
                rel="noreferrer"
              >
                <Image src={facebookLogo} m={2} height={21}></Image>
              </a>

              <a
                style={{ textDecoration: "none" }}
                href="https://twitter.com/Herno_official"
                target="_blank"
                rel="noreferrer"
              >
                <Image src={twitterLogo} m={2} height={21}></Image>
              </a>

              <a
                style={{ textDecoration: "none" }}
                href="https://www.instagram.com/herno_official/"
                target="_blank"
                rel="noreferrer"
              >
                <Image src={instagramLogo} m={2} height={21}></Image>
              </a>

              <a
                style={{ textDecoration: "none" }}
                href="https://www.pinterest.it/hernospa/"
                target="_blank"
                rel="noreferrer"
              >
                <Image src={pinterestLogo} m={2} height={21}></Image>
              </a>
            </Flex>
            <Button
              sx={{
                width: ["80%", "fit-content"],
                background: "#bab8b8",
                textTransform: "uppercase",
                fontWeight: 600,
                paddingX: "32px",
                marginTop: "20px",
              }}
              disabled={maintenanceButtonDisabled}
              onClick={() => {
                setMaintenanceButtonDisabled(true);
                yodaMaintenanceService.getInfoMaintenance().then((status) => {
                  resetCache();
                  setMaintenanceButtonDisabled(false);
                  if (!status) {
                    window.location.href = "/homepage";
                  }
                });
              }}
            >
              {getLocalizedString("MAINTENANCE_RELOAD_CTA")}
            </Button>
          </Flex>
          <Flex
            flexGrow={1}
            height={50}
            bg={theme.background}
            alignItems="center"
            mt={10}
            pt={10}
            pb={10}
            fontSize={"0.6em"}
            color="white"
            justifyContent={"center"}
          >
            <Box
              width={["100%", config.VIEWPORT]}
              py={2}
              textAlign={["center", "start"]}
            >
              COPYRIGHT &copy; HERNO S.P.A {new Date().getFullYear()} - ALL
              RIGHTS RESERVED
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default MaintenancePage;
